import { useQuery } from "@tanstack/react-query";
import { specialtiesApi, type Specialty } from "../../api/specialties.api";
import { queryKeys } from "../../lib/react-query/queryKeys";
import { ALLOWED_SPECIALTIES } from "../../lib/validation/schemas/auth.schema";

/** Fallback list used while loading or if Firestore returns empty */
const FALLBACK_SPECIALTIES: Specialty[] = ALLOWED_SPECIALTIES.map((name) => ({
  id: name.toLowerCase().replace(/\s+/g, "_"),
  name,
  country: "AU",
}));

/**
 * Fetches specialties from Firestore `specialties` collection.
 * Falls back to the static ALLOWED_SPECIALTIES list if the fetch fails or returns empty.
 * staleTime is Infinity — specialties are reference data that rarely changes.
 */
export const useSpecialties = () => {
  return useQuery({
    queryKey: queryKeys.specialties.list(),
    queryFn: specialtiesApi.getSpecialties,
    staleTime: Infinity,
    select: (data) => (data.length > 0 ? data : FALLBACK_SPECIALTIES),
  });
};
